<template>
    <div id="voiceRecorder">
        <!-- Kayit surdugunu gosteren tek isaret gorsellestiriciydi; mikrofon
             acilamadiginda o da bos kaliyor ve kaydin isleyip islemedigi
             anlasilmiyordu. Yanip sonen nokta ile sayac her durumda gorunur. -->
        <span class="recDot" aria-hidden="true"></span>
        <span class="recTime">{{ formattedDuration }}</span>
        <av-media :media="media" :type="'frequ'"></av-media>
        <div class="control-panel">
            <md-button
                v-if="$store.state.voiceRecorder.isRecording"
                class="actionBtn md-icon-button md-dense"
                @click="() => stopRecord(true)"
            >
                <md-icon style="color:var(--button-color)">stop</md-icon>
            </md-button>
            <EllipsIconButton
                hovered-icon-color="white"
                icon-name="Check"
                width="17px"
                icon-color="var(--button-color)"
                hovered-bg-color="var(--header-color)"
                padding="14px"
                @btnClicked="setRecording(false)"
            />
       </div>
    </div>
</template>

<script>
import { getRecorder } from "../util/voiceRecorder";
import { mapMutations } from "vuex";
import EllipsIconButton from "../../common/IconButton.vue";

export default {
    name: "VoiceRecorder",
    components: { EllipsIconButton },
    props: ["cb"],
    data() {
        return {
            duration: 0,
            interval: null,
            maxSec: 60,
            media: null,
        };
    },
    computed: {
        formattedDuration() {
            const dk = Math.floor(this.duration / 60);
            const sn = this.duration % 60;
            return `${dk}:${String(sn).padStart(2, "0")}`;
        },
    },
    methods: {
        ...mapMutations({
            setRecording: "voiceRecorder/SET_RECORDING", // map `this.add()` to `this.$store.commit('increment')`
        }),
        hexToRgb(data, num) {
            const hex = data.replace("#", "");
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);
            return `rgb(${r - num} ${g - num} ${b - num})`;
        },
        async startRecord() {
            this.duration = 0;
            getRecorder().start(
                (e) => {
                    this.media = e.target.stream;
                    // Sayac kayit gercekten baslayinca isliyor; izin beklenirken
                    // saniye saymak "kaydediyor" yanilgisi veriyordu.
                    clearInterval(this.interval);
                    this.interval = setInterval(() => this.duration++, 1000);
                },
                () => {
                    // Mikrofon izni yok ya da cihaz acilamadi: kayit durumundan cik.
                    this.media = null;
                    clearInterval(this.interval);
                    this.duration = 0;
                    this.setRecording(false);
                    this.$emit("error");
                }
            );
        },
        stopRecord(cancel = false) {
            getRecorder().stop(cancel ? () => {} : this.cb);
            this.media = null;
            this.setRecording(false);
            clearInterval(this.interval);
            this.duration = 0;
        },
    },
    watch: {
        "$store.state.voiceRecorder.isRecording": function (val) {
            if (val) {
                this.startRecord();
            } else {
                this.stopRecord();
            }
        },
        duration(newVal, oldVal) {
            if (newVal >= this.maxSec) {
                getRecorder().stop(this.cb);
                this.setRecording(false);
                clearInterval(this.interval);
                this.duration = 0;
            }
        },
    },
    beforeDestroy() {
        getRecorder().stop(() => {});
        clearInterval(this.interval);
    },
};
</script>

<style lang="scss">
@keyframes recPulse {
    0%, 100% { opacity: 1; }
    50% { opacity: .25; }
}

#voiceRecorder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-left: 5px;
    .recDot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #e11d48;
        flex: 0 0 8px;
        margin-right: 6px;
        animation: recPulse 1.2s ease-in-out infinite;
    }
    .recTime {
        font-size: 12px;
        font-variant-numeric: tabular-nums;
        color: var(--primary-text);
        margin-right: 8px;
        min-width: 34px;
    }
    .control-panel {
        display:flex;
        justify-content: center;
        align-items: center;
        .actionBtn {
          margin-right: 4px
        }
    }
    .recorderProgress {
        flex-grow: 10;
    }
    .ant-progress-outer {
        .ant-progress-inner {
            .ant-progress-bg {
                background-color: var(--header-color);
            }
        }
    }

    .ant-progress-text {
        user-select: none !important;
        color: var(--primary-text) !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/VoiceRecorder.vue